import { render, staticRenderFns } from "./BaseSpiner.vue?vue&type=template&id=daeb31d6&scoped=true&"
import script from "./BaseSpiner.vue?vue&type=script&lang=js&"
export * from "./BaseSpiner.vue?vue&type=script&lang=js&"
import style0 from "./BaseSpiner.vue?vue&type=style&index=0&id=daeb31d6&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daeb31d6",
  null
  
)

export default component.exports